import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, DoCheck, HostListener} from '@angular/core';
import { ApiService } from '@app/gateway/services/api.service';
import { UserProfileService } from '@app/gateway/user-profile/user-profile.service';
import { ModalService } from '@app/services/modal/modal.service';
import { mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpHeaders } from '@angular/common/http';
import { ServiceConfigService } from '@app/services/service-config.service';
import { TokenService } from '@app/services/token/token.service';

@Component({
    selector: 'nh-proof-upload',
    templateUrl: './proof-upload.component.html',
    styleUrls: ['./proof-upload.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ProofUploadComponent implements OnInit, DoCheck {
  @Input() appTrackingNum;
  @Input() kbDataList;
  @Input() bccCase;
  @Input() caseNumber;
  @Output() docUploadSuccess = new EventEmitter<any>();
  rows;
  data = [];
  documents = [{ docType: null, show: true, file: null, error: false, pageId: null, groupId: null }];
  docType = null;
  proofType = null;
  referenceData;
  options;
  code;
  error = true;
  showAnother = false;
  showCZPRmessage = false;
  docOptions = [];
  appTrackNum;
  submissionType;
  currentDocTypeObj;
  userId;
  kbDocument;
  refId = null;
  proofTypeError = false;
  displayLoading = false;
  docName: string;
  displayUpload = true
  finalTableDispalyed: any;
  columns = [{
    name: 'Name', prop: 'fullName'
  },
  { name: 'Case', prop: 'caseNum' },
  { name: 'Information Needed', prop: 'verfDesc' },
  { name: 'Due Date', prop: 'verfDue' }]

  houseHoldColumns = [
    { name: 'Head of Household', prop: 'hohName' },
    { name: 'Submission Type', prop: 'type' },
    { name: 'Date of Submission', prop: 'submissionDate' }
  ];

  kbColumns = [
    { name: 'Name', prop: 'fullName' },
    { name: 'Ref Id', prop: 'refId' }
  ]
  householdRows;
  appealRows;
  response;
  kbRows;
  screenHeight: number;
  screenWidth: number;
  isMobileView = false;
  mobileWidth = 480;
  defaultLanguage;
  translatedLang;
  appealsUpload;
  appealOption;
  continueClick = false;
  successDocUpload = false;
  currentDocType;
  changeType = false;
  currentI;
  filteredDocs = [];
  diffDocTypes = [{ docType: null, show: true, file: null, error: false, commonItems: [] , groupId: null}];
  showClose = false;
  currentDocCode;
  partnerOrgDocSwitch: boolean = false;

  
  @HostListener('window:beforeunload')
  beforeUnloadHander() {
    if (sessionStorage.getItem('fromMyAppeals') === 'true') {
      sessionStorage.setItem('myAppealsUploadProof', 'true');

    }
  }

  constructor(private apiService: ApiService, private userProfileService: UserProfileService, public translateService: TranslateService,
    private modalService: ModalService, private serverConfig: ServiceConfigService, private token: TokenService) {
  }
  @HostListener('window:resize')
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  ngDoCheck() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
  }

  clickChangeType() {
    this.changeType = true;
    if(this.showClose) {
      this.closeMobile()
    }

  }

  addAnother() {
    this.documents.push({
      docType: null,
      show: true,
      file: null,
      error: false,
      pageId: null, 
      groupId: null
    });
    this.addDocbuttonVisibility();
  }

  addAnotherMobile() {
    if(this.successDocUpload) {
      let currentDocyType = this.filteredDocs[0]?.docType
      this.currentI = this.currentI + 1;
      this.documents.push({
        docType: currentDocyType,
        show: true,
        file: null,
        error: false,
        pageId: null, 
        groupId: null
      });
      this.diffDocTypes.push({
        docType: currentDocyType,
        show: true,
        file: null,
        error: false,
        commonItems: [],
        groupId: null
      });
      if (this.filteredDocs?.length >= 25) {
        this.modalService.openMaxDocUploadLimit().subscribe;
        this.showClose = false;
      } else {
        this.addDocbuttonVisibility();
        this.showClose = true
      }
    } else {
      this.documents.push({
        docType: null,
        show: true,
        file: null,
        error: false,
        pageId: null, 
        groupId: null
      });
      this.diffDocTypes.push({
        docType: null,
        show: true,
        file: null,
        error: false,
        commonItems: [],
        groupId: null
      });

      this.addDocbuttonVisibility();
    }    
  }

  ngOnInit() {
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      if (this.currentDocType) {
        this.currentDocType = this.translatedLang !== 'en' ? this.currentDocTypeObj?.['spDescription'] : this.currentDocTypeObj?.['enDescription']
      }
    });
    this.partnerOrgDocSwitch = this.serverConfig.getServerConfig().PP_ORG_DOC_SW;
    // if(sessionStorage.getItem('diffDocuments')) {
    //   this.diffDocTypes = JSON.parse(sessionStorage.getItem('diffDocuments'));
    //   this.documents = JSON.parse(sessionStorage.getItem('documents'));
    //   this.filteredDocs = JSON.parse(sessionStorage.getItem('filteredDocuments'));
    //   this.proofType = JSON.parse(sessionStorage.getItem('proofType'));
    //   this.changeProofType();
    //   this.onContinue();
    //   sessionStorage.removeItem('diffDocuments');
    //   sessionStorage.removeItem('documents');
    //   sessionStorage.removeItem('proofType')
    // }
    if (this.appTrackingNum){
      this.appTrackNum = this.appTrackingNum.includes(':')? this.appTrackingNum?.split(':')[1] : this.appTrackingNum;
      this.submissionType = this.appTrackingNum.includes(':')? this.appTrackingNum?.split(':')[0] : '';
    };
    if (!this.bccCase) {
      const url = `publ/reference-tables/retrieve?table=TTOP`;
    this.apiService.get(url, null, {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
      this.options = this.kbDataList ? [...res['columnDetails']] : res['columnDetails'].filter(col => col.code !== 'KBPR');
      this.options = this.options?.filter(col => col.code !== 'VFPR' && col.code !== 'APPR' && col.code !== 'MAPR' && col.code !=='KBPR' && col.code !=='PTPR');
      if (sessionStorage.getItem('myAppealsUploadProof') === 'true') {
        this.appealsUpload = true;
        this.appealOption = {'code': "VFPR", 'enDescription': "Appeal Facts Document", 'rowid': "1", 'spDescription': "Documentos de información para la apelación"}
        this.proofType = this.appealOption;
        this.changeProofType();
        sessionStorage.removeItem('myAppealsUploadProof');
        sessionStorage.setItem('fromMyAppeals', 'true');
      }
    });
  } else {
    const url = `publ/reference-tables/retrieve?table=TTOV`;
    this.apiService.get(url, null,  {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
      this.options = res['columnDetails'].filter(col => col.code === 'BCPR');
    });
  }
    this.getCmbData();
  }

  getCmbData() {
    const indivId = sessionStorage.getItem('individualId');
      this.userProfileService.getDocumentsWeNeed(indivId, 'TCMUD').pipe(mergeMap((res: any): Observable<any> => {
        this.response = { ...res }
        const url = 'publ/reference-tables?tables=TVDC';
        return this.apiService.get(url, null,  {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})});
      })).subscribe((res) => {
        let tableDisplayed = [];
        this.referenceData = [...res.referenceGroup[0].referenceData];
        this.response['cmbCaseIndvData'].forEach((item) => {
          if (item.verfCd !== 'AS') {
            tableDisplayed.push(res.referenceGroup[0].referenceData.filter(tableData => tableData.code == item.verfCd)[0].value);
          } else if (item.verfCd === 'AS') {
            tableDisplayed.push('ASPR');
          }
        })
        if (this.bccCase) {
          tableDisplayed.push('BCPR');
        } 
        this.finalTableDispalyed = tableDisplayed.filter((c, index) => {
          return tableDisplayed.indexOf(c) === index;
        });
      })
  }
    
  
  showProofTypes() {
    this.modalService.openTypesOfProofs(this.finalTableDispalyed);
  }

  changeProofType() {
    if (this.proofType) {
      this.kbDocument = this.proofType.code === 'KBPR' ? true : false;
      const url = `publ/reference-tables/retrieve?table=${this.proofType.code}`;
      this.apiService.get(url, null,  {headers: new HttpHeaders({'pageId': 'TCMUD', 'sessionId' : this.token.getSessionId()})}).subscribe((res) => {
        this.docOptions = [...res['columnDetails']];
      });
    } else {
      this.proofTypeError = true;
      this.addDocbuttonVisibility();
    }
  }
  selectedOption(i) {
    this.documents[i].error = !this.documents[i].docType;
    if (this.documents[i].docType !== null) {
      this.setCZPRmessage(i);
    }
    this.addDocbuttonVisibility();
  }


  selectedOptionMobile(i) {
    let prevDocType;
    this.currentDocTypeObj = this.diffDocTypes[i]?.docType;
    let currentDocType = this.diffDocTypes[i].docType;
    this.currentDocType = this.translatedLang !== 'en' ? this.diffDocTypes[i]['docType']['spDescription'] : this.diffDocTypes[i]['docType']['enDescription']
    for (let j = 0; this.documents.length > j; j++) {
      if (this.documents[j].docType === null || this.documents[j]['file'] === null) {
        this.documents[j]['docType'] = this.diffDocTypes[i].docType
      } 
      if (this.documents[j]?.['file'] && this.diffDocTypes[i]?.['file'] && (this.documents[j]?.['file']?.['res'] === this.diffDocTypes[i]?.['file']?.['res'])) {
        prevDocType = this.documents[j].docType
        this.documents[j]['docType'] = this.diffDocTypes[i].docType
      }
      if(this.successDocUpload)  {
      const index = this.diffDocTypes.findIndex(k => k['file'] && this.documents[j]?.['file'] && (k['file']?.['res'] === this.documents[j]?.['file']?.['res']));
      if (this.diffDocTypes[i]['file'] === null && index >= 0 && this.diffDocTypes[index]?.docType?.code !== currentDocType?.code) {
        prevDocType = this.diffDocTypes[index]?.docType
        this.diffDocTypes[index].docType = currentDocType
        this.documents[j]['docType'] = currentDocType
      }
    }

    }
if(prevDocType) {
    for(let j = 0; this.documents.length > j; j++) {
      if(this.documents[j]['docType']['code'] === prevDocType?.code) {
        this.documents[j]['docType'] = currentDocType
      }
    }
    this.diffDocTypes.forEach(item => {
      if (item['commonItems'][0] === prevDocType?.code) {
        for (let k = 0; item['commonItems'].length > k; k++) {
          item['commonItems'][k] = currentDocType?.code
        }
      }
      if (item['docType'] === prevDocType) {
        item['docType'] = currentDocType
      }
    })
    if (this.successDocUpload && prevDocType === this.filteredDocs[0]['docType']) {
      this.documents = this.documents.filter(item => item['file'] !== null)
      this.diffDocTypes = this.diffDocTypes.filter(item => item['file'] !== null)
      this.filteredDocs.forEach(item => {
        item['docType'] = currentDocType
      })
    }
  }
    this.documents[i].error = !this.documents[i]?.docType;
    if (this.documents[i]?.docType !== null) {
      this.setCZPRmessage(i);
    }
    this.changeType = false
    this.addDocbuttonVisibility();
  }

  setCZPRmessage(i) {
    const vals = [...this.documents];
    const proofType = vals[i].docType ?.code;
    if (vals.length === 1 && this.proofType.code === 'CZPR') {
      this.showCZPRmessage = ["BC", "US", "CC"].includes(proofType);
    } else {
      this.showCZPRmessage = false;
    }
  }

  removeItem(i) {
    this.modalService.confirmDelete().subscribe((res) => {
      if (res) {
        this.documents[i].file = null;
        this.documents[i].show = true;
        this.addDocbuttonVisibility();
      }
    })
  };

  removeItemMobile(i) {
    let headers = new HttpHeaders({
      action: 'delete',
      'pageId': 'TCMUD',
      'sessionId' : this.token.getSessionId()
    })
    if(this.successDocUpload) {
      this.modalService.confirmDelete().subscribe((res) => {
        if (res) {
          const docId= this.filteredDocs[i]?.['file']?.['res']
          const removeUrl = `indi/neededDocuments/document/${docId}`;
          this.apiService.post(removeUrl, null,{headers: headers}).subscribe(() => {})
          const deleteDocumentDocType = this.filteredDocs[i]['docType']?.['code']
          this.documents.forEach(item => {
            if((item['docType']?.['code'] === this.filteredDocs[i]['docType']?.['code']) && (item['file']?.['res'] === this.filteredDocs[i]['file']?.['res'])) {
               item['file'] = null;
               item['show'] = true;
            }
          })
          this.diffDocTypes = this.diffDocTypes?.filter((item, index, self) =>
            index === self.findIndex((t) => (
              t['docType']['code'] === item['docType']['code']
            ))
          )
          this.diffDocTypes?.forEach(item => {
            if(item['docType']?.['code'] === this.filteredDocs[i]['docType']?.['code']) {
              //  item['file'] = null;
              //  item['show'] = true;
               item['commonItems'].pop()
            }
          })
          this.documents = this.documents?.filter(item => item['file'] !== null)
          this.filteredDocs[i].file = null;
          this.filteredDocs[i].show = true;
          this.filteredDocs = this.filteredDocs?.filter(item => item['docType']['spDescription'] === this.currentDocType || item['docType']['enDescription'] === this.currentDocType)
          this.filteredDocs = this.filteredDocs?.filter(item => item['file'] !== null)
          this.successDocUpload = this.filteredDocs.length ? true: false;
          if(!this.filteredDocs.length) {
            this.diffDocTypes.forEach(item => {
              if(item['docType']?.['code'] === deleteDocumentDocType) {
                 item['docType'] = null
                 item['file'] = null;
                 item['show'] = true;
                 item['commonItems'].pop()
              }
            })
          } else {
            this.diffDocTypes.forEach(item => {
              if(item['docType']?.['code'] === deleteDocumentDocType) {
                 item['file'] = this.filteredDocs[0]['file'];
              }
            })
          }
          this.diffDocTypes = this.diffDocTypes.length > 1 ? this.diffDocTypes.filter(item => item['file'] !== null) : this.diffDocTypes;
          this.diffDocTypes = !this.diffDocTypes.length ? [{ docType: null, show: true, file: null, error: false, commonItems: [], groupId: null }] : this.diffDocTypes
          this.documents = !this.documents.length ? [{ docType: null, show: true, file: null, error: false , pageId: null, groupId: null}] : this.documents
          this.addDocbuttonVisibility();
          this.showClose = false
        }
      })
    } else {
      this.modalService.confirmDeleteMobile().subscribe((res) => {
        if (res ) {
          const removeDocumentGroup = this.diffDocTypes[i]['groupId']  
          this.documents.forEach((item) => {
            if(item['groupId'] === removeDocumentGroup) {
              const docId = item['file']?.['res']
              const removeUrl = `indi/neededDocuments/document/${docId}`;
              this.apiService.post(removeUrl, null,{headers: headers}).subscribe(() => {})
            }
          })
          this.documents = this.documents.filter(a => a['groupId'] !== removeDocumentGroup);
          this.filteredDocs = this.filteredDocs.filter(a => a['groupId'] !== removeDocumentGroup)
          this.diffDocTypes.splice(i, 1);
          this.diffDocTypes = !this.diffDocTypes.length ? [{ docType: null, show: true, file: null, error: false, commonItems: [], groupId: null }] : this.diffDocTypes
          this.documents = !this.documents.length ? [{ docType: null, show: true, file: null, error: false, pageId: null, groupId: null }] : this.documents
          this.addDocbuttonVisibility();
        }
      })
    }
  };

  close(i: any) {
    this.documents.splice(i, 1);
    this.addDocbuttonVisibility();
  };

  closeMobile() {
    this.documents = this.documents.filter(item => item['file'] !== null)
    this.diffDocTypes = this.diffDocTypes.filter(item => item['file'] !== null)
    this.currentI = this.currentI - 1
    this.addDocbuttonVisibility();
    this.showClose = false
  };
  trackByIdx(index: number): any {
    return index;
  }

  onContinue() {
    this.successDocUpload = false;
    sessionStorage.removeItem('MobileDocuUploadedScreen');
    this.scrollToCenter();
    this.filterIdenticalItems()
  }

  filterIdenticalItems() {
    this.diffDocTypes.forEach(item => {
      item['commonItems'] = []
      this.documents.forEach(data => {
        if (item['docType']?.['code'] === data['docType']?.['code'] && item['groupId'] === data['groupId']) {
          item['commonItems'].push(item['docType']['code']);
          item['show'] = data['show']
          item['file'] = data['file']

        }
      })
    })
    this.diffDocTypes = this.diffDocTypes.filter((item, index, self) =>
      index === self.findIndex((t) => (t['groupId'] === item['groupId'] && t['docType']['code'] === item['docType']['code'])))
  }

  getFileDetails(fileData, i) {
    if (fileData.res !== null) {
      this.documents[i].show = false;
      this.documents[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      this.addDocbuttonVisibility();
      this.setCZPRmessage(i);
      //this.error = false;
    }
  }

  getFileProgress(event) {
    if (event) {
      this.displayLoading = event.displayLoading;
      this.docName = event.fileName;
      this.displayUpload = this.displayLoading ? false : true
    } else {
      this.displayLoading = false;
      this.docName = null;
      this.displayUpload = this.displayLoading ? false : true
    }
  }
  
  
  getFileDetailsMobile(fileData, i) {
    let currentGroupId;
    if (fileData.res !== null) {
      const index = this.diffDocTypes.findIndex(k => k['file'] === null && k['docType']?.['code'] === this.currentDocTypeObj?.['code'] );
      if(index >= 0) {
        i= index;
      }
      if(this.diffDocTypes[i]){
        this.diffDocTypes[i].show = false;
        this.diffDocTypes[i].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
      }
      for(let j=0; this.documents.length > j; j++) {
        if(this.documents[j]?.['docType']?.['code'] === this.diffDocTypes[i]?.['docType']?.['code'] && this.documents[j].file === null){
          this.documents[j].show = false;
          this.documents[j].file = { ...fileData.fileRes.file, ...{ res: fileData.res } };
          if(this.successDocUpload === false) {
            if(j === 0 ) {
              this.documents[j].groupId =  1
              this.documents[j].pageId = 1
                currentGroupId = this.documents[j].groupId
            } else {
              this.documents[j].groupId = this.documents[j-1]?.groupId + 1
              this.documents[j].pageId =  1
              currentGroupId = this.documents[j].groupId
            }
            
          }
          if(this.successDocUpload === true) {
            this.documents[j].pageId = this.documents[j-1].pageId  + 1
            this.documents[j].groupId = this.documents[j-1].groupId           
            currentGroupId = this.documents[j].groupId
          }
          this.documents[j]['filePreview'] = this.documents[j]['file']['rawFile']['filePreview']
        }
      }
      this.addDocbuttonVisibility();
      this.setCZPRmessage(i);
      this.successDocUpload = true
      if (this.successDocUpload === true) {
        sessionStorage.setItem('MobileDocuUploadedScreen', 'true');
        this.scrollToTop()
      }
      this.currentDocType = this.translatedLang !== 'en' ? this.diffDocTypes[i]?.['docType']?.['spDescription'] : this.diffDocTypes[i]?.['docType']?.['enDescription']
      this.currentI = i
      this.filteredDocs = this.documents.filter(item => item['groupId'] === currentGroupId &&  (item['docType']?.['spDescription'] === this.currentDocType || item['docType']?.['enDescription'] === this.currentDocType));
      this.showClose = false
      this.diffDocTypes[i]['groupId'] = currentGroupId
    }
  }
  addDocbuttonVisibility() {
    this.error = this.documents.some(doc => doc.file == null || doc.docType == null);
  }

  scrollToTop() {
    setTimeout(() => {
        const container = document.body.querySelector('.mat-sidenav-content');
        if (container) {
            container.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        }
    }, 100)
}

  scrollToCenter() {
    setTimeout(() => {
      const container = document.body.querySelector('.mat-sidenav-content');
      if (container) {
        const scrollHeight = container.scrollHeight;
        const clientHeight = container.clientHeight;
        const scroolLevel = (scrollHeight - clientHeight) / 2;
        container.scrollTo({ top: scroolLevel, left: 0, behavior: 'smooth' });
      }
    }, 100)
  }

  onEdit(i, doc){
    const groupId = doc['groupId']
    this.documents = this.documents.filter(item => item['file'] !== null)
    this.diffDocTypes = this.diffDocTypes.filter(item => item['file'] !== null)
    this.successDocUpload = true;
    if (this.successDocUpload === true) {
      sessionStorage.setItem('MobileDocuUploadedScreen', 'true');
      this.scrollToTop()
    }
    this.currentDocType = this.translatedLang !== 'en' ? this.diffDocTypes[i]['docType']?.['spDescription'] : this.diffDocTypes[i]['docType']?.['enDescription'];
    this.currentDocCode =  this.diffDocTypes[i]['docType']['code']
    this.filteredDocs = this.documents.filter(item => item['groupId'] === groupId && (item['docType']?.['spDescription'] === this.currentDocType || item['docType']?.['enDescription'] === this.currentDocType))
    this.currentI = i;
    this.changeType = false;
    this.addDocbuttonVisibility();
  }

  viewPdf(i, source) {
    const docId = source === 'mobileBrowser' ? this.filteredDocs[i].file.res.replace(/[{}]/g, "") : this.documents[i].file.res.replace(/[{}]/g, "");
    this.userProfileService.getPrintDoc(docId, 'TCMUD').subscribe((res: any) => {
      let newVariable: any;
      newVariable = window.navigator;
      const file = new Blob([res], { type: 'application/pdf' });
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(file);
      } else {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    })
  }

  submitDocuments(from) {
    let submitUrl;
    if(from === 'desktop'){
      submitUrl = `indi/neededDocuments/submitDocuments`;
    } else {
      submitUrl = `indi/neededDocuments/mergeDocuments`;
    }
    const userType = sessionStorage.getItem('userType');
    const user = JSON.parse(sessionStorage.getItem('currentUser'));
    this.userId = userType && userType === 'RP' ? sessionStorage.getItem('userName') : user.userId;
    let indiv;
    if (this.proofType.code === 'KBPR') {
      indiv = this.refId?.kbIndvNum;
    } else {
      indiv = sessionStorage.getItem('individualId');
    }
    const types = this.documents.map(doc => {
      return {
        "documentType": { code: this.proofType.code, value: this.proofType.enDescription },
        "documentSubType": { code: doc.docType.code, value: doc.docType.enDescription },
        "documentId": doc.file.res,
        "indvId": indiv,
        "groupId": doc.groupId,
        "pageId": doc.pageId,
        "fileName": doc.file.name,
        "fileSize": doc.file.size,
        "fileType": doc.file.type
      }
    })
    if(this.appTrackingNum){this.appTrackNum = this.appTrackingNum.includes(':')? this.appTrackingNum?.split(':')[1] : this.appTrackingNum;};
    const uploadData = {
      refId: this.refId ? this.refId.kbReferralId : null,
      tNumber: this.appTrackNum,
      userId: this.userId,
      typeOfDocument: [...types],
      caseNumber: this.caseNumber,
      entityId: null
    }

    if (this.partnerOrgDocSwitch) {
      const entityId = sessionStorage.getItem('mtlToken');
      if (entityId) {
        uploadData.entityId = entityId;
      }
    }
    const contentHeader = new HttpHeaders({'pageId':'TCMUD', 'sessionId' : this.token.getSessionId()})
    this.apiService.post(submitUrl, uploadData,{headers: contentHeader}).subscribe(() => {
      this.docUploadSuccess.emit({ success: true })
    })
  }
}